import React from 'react';
const Payment = () => {
    return (
        <div>
            <h3>Payment</h3>
        </div>
    );
};

export default Payment;